import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import './_CharacterCounter.scss';

type Props = {
    maxChars: number;
    currentChars: number;
};

export default function CharacterCounter({ maxChars, currentChars }: Props) {
    const { t } = useTranslation('words');
    const [isMax, setIsMax] = useState(false);

    useEffect(() => {
        if (currentChars >= maxChars) {
            setIsMax(true);
        } else {
            setIsMax(false);
        }
    }, [currentChars, maxChars]);

    const maxClass = isMax ? 'max-chars' : '';
    return (
        <div className={`CharacterCounter ${maxClass}`}>
            <p className="char-text">{`${currentChars}/${maxChars} ${t('characters')}`}</p>
        </div>
    );
}
